import {
    CUSTOM_ELEMENTS_SCHEMA,
    Component,
    ElementRef,
    Input,
    ViewChild,
    OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { HomePageService } from 'app/modules/landing/home/home.service';
import { GtmService } from 'app/services/gtm.service';
import { MatButtonModule } from '@angular/material/button';
import { ToastrService } from 'ngx-toastr';
import { FooterSubscribeComponent } from '../footer-subscribe/footer-subscribe.component';
import { NewFooterComponent } from './components/new-footer/new-footer.component';
import { NewFooterV2Component } from './components/new-footer-v2/new-footer-v2.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        RouterModule,
        TranslateModule,
        FooterSubscribeComponent,
        NewFooterComponent,
        NewFooterV2Component
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FooterComponent implements OnDestroy {
    productList: any;
    nav = [false, false, false];
    gtmTags: any = [];
    isJC3: boolean = false;
    @Input() selectedLanguage: any;

    isFooterVisible: boolean = false;
    isScrolledDownEnough: boolean = false;
    hideScrollButton: boolean = false;
    lang: any;

    @ViewChild('footer', { static: true }) footer!: ElementRef;

    private scrollHandler = this.onScroll.bind(this);

    constructor(
        private homeService: HomePageService,
        private gtmService: GtmService,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastrService
    ) {
        this.route.url.subscribe((segments) => {
            this.gtmTags = this.gtmService.getFooterGtmTags(segments);
        });

        this.lang = this.selectedLanguage ? this.selectedLanguage : 'bm';

        if (this.router.url.includes('/business-financing')) {
            this.isFooterVisible = false;
        }

        if (this.router.url.includes('/jc3')) {
            this.isJC3 = true;
        }
    }

    ngOnInit(): void {
        this.observeFooter();
        this.checkRoute();
        let language = localStorage.getItem('language');
        this.selectedLanguage = language ? language : 'en';
        window.addEventListener('scroll', this.scrollHandler); // Add scroll listener
    }

    ngOnDestroy(): void {
        window.removeEventListener('scroll', this.scrollHandler); // Remove on destroy
    }

    togglenav(idx: number) {
        this.nav[idx] = !this.nav[idx];
    }

    getProductList() {
        this.homeService.getProductList().subscribe({
            next: (x) => {
                this.productList = x;
            },
            error: (err) => {
                this.toastr.error(err.error.message);
            },
        });
    }

    observeFooter() {
        const observer = new IntersectionObserver(
            ([entry]) => {
                this.isFooterVisible = entry.isIntersecting;
            },
            { threshold: 0.1 }
        );
        if (this.footer?.nativeElement) {
            observer.observe(this.footer.nativeElement);
        }
    }

    checkRoute() {
        this.router.events.subscribe(() => {
            const hiddenRoutes = [
                '/business-financing',
                '/cgc-developmental-programme',
            ];
            this.hideScrollButton = hiddenRoutes.includes(this.router.url);
        });
    }

    scroll() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    private onScroll(): void {
        this.isScrolledDownEnough = window.scrollY >= 786;
    }
}
